var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 22,
    viewBox: "0 0 44 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 6.34315 1.34315 5 3 5H41C42.6569 5 44 6.34315 44 8V15H0V8Z",
    fill: "#002B49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7637 10.9998C22.7637 10.5779 22.4217 10.2359 21.9998 10.2359C21.5779 10.2359 21.2359 10.5779 21.2359 10.9998C21.2359 11.4217 21.5779 11.7637 21.9998 11.7637C22.4217 11.7637 22.7637 11.4217 22.7637 10.9998Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4164 10.9998C17.4164 10.5779 17.0744 10.2359 16.6526 10.2359C16.2307 10.2359 15.8887 10.5779 15.8887 10.9998C15.8887 11.4217 16.2307 11.7637 16.6526 11.7637C17.0744 11.7637 17.4164 11.4217 17.4164 10.9998Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1109 10.9998C28.1109 10.5779 27.7689 10.2359 27.347 10.2359C26.9251 10.2359 26.5831 10.5779 26.5831 10.9998C26.5831 11.4217 26.9251 11.7637 27.347 11.7637C27.7689 11.7637 28.1109 11.4217 28.1109 10.9998Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/ThreeDots.256295aaa6ff96f31bf26580249eae70.svg";
export { ForwardRef as ReactComponent };